const getters = {
    menuList: state => state.menuList,
    navTags: state => state.navTags
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js